<template>
  <span>
    <point-toolbar :point-info="point.name" />
    <v-card v-if="addTask">
      <v-card-title>
        <span class="headline">{{ taskDialogTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container grid-list-md>
          <v-flex>
            <v-row>
              <v-col
                cols="2"
                class="mt-3"
              >Частота выполнения</v-col>
              <v-col cols="10">
                <v-chip-group
                  v-model="cronVal"
                  active-class="primary--text"
                >
                  <v-chip
                    v-for="interval in intervals"
                    :key="interval.value"
                    :value="interval.value"
                  >
                    {{ interval.text }}
                  </v-chip>
                </v-chip-group></v-col>
            </v-row>
          </v-flex>
          <v-form ref="scheduleForm">
            <v-layout wrap>
              <v-flex
                xs12
                sm12
                md12
              >
                <v-combobox
                  v-model="tmpTaskGroups"
                  :items="taskGroups"
                  item-text="name"
                  item-value="group_id"
                  label="Группа параметров"
                  :chips="true"
                  multiple
                />
              </v-flex>

              <v-flex
                xs12
                sm12
                md12
              >
                <v-combobox
                  v-model="tmpParameters"
                  :items="counterParameters"
                  item-text="name"
                  item-value="model_parameter_id"
                  label="Собираемые параметры"
                  :chips="true"
                  multiple
                  disabled
                />
              </v-flex>
              <v-flex
                xs12
                sm12
                md12
              >
                <v-layout>
                  <v-flex>
                    <v-autocomplete
                      v-model="editedTaskItem.data_collecting_server_id"
                      :items="dataCollectingServers"
                      label="Сервер сбора данных"
                      item-text="server_name"
                      item-value="data_collecting_sever_id"
                      :menu-props="{maxHeight:'auto'}"
                      :rules="inputRules"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="blue darken-1"
          text
          @click.native="saveCounterTask()"
        >Сохранить</v-btn>
        <v-btn
          color="blue darken-1"
          text
          @click.native="closeTasksDialog()"
        >Отмена</v-btn>
      </v-card-actions>
    </v-card>

    <v-layout
      v-else-if="tasksLoading"
      justify-center
      align-center
      class="loading-indicator"
    >
      <v-progress-circular
        indeterminate
        :size="70"
        :width="7"
      />
    </v-layout>

    <v-card
      v-else
      class="point-sheduler-card"
    >
      <v-btn
        v-if="point.counter_id"
        fab
        color="primary"
        class="add-scheduler-button"
        @click.native="addCounterTask()"
      >
        <v-icon>add</v-icon>
      </v-btn>

      <v-data-table
        :headers="counterTasksHeaders"
        :items="counterTasks"
        fixed-header
        hide-default-footer
        dense
      >
        <tr
          slot="item"
          slot-scope="props"
        >
          <td>
            {{ props.item.counter_num }}
          </td>
          <td>
            <span class="action-btns">
              <span v-if="props.item.state === 'working'">
                <v-btn
                  icon
                  class="mt-1"
                  title="Остановить выполнение расписания"
                  @click="stopTasks(props.item)"
                >
                  <v-icon color="red darken-1">stop</v-icon>
                </v-btn>
              </span>
              <span v-else>
                <v-btn
                  icon
                  class="mt-1"
                  title="Запустить выполенение расписания"
                  @click="startTasks(props.item)"
                >
                  <v-icon
                    v-if="props.item.state === 'stopped'"
                    color="green darken-1"
                  >play_arrow</v-icon>
                  <v-icon
                    v-else
                    color="yellow darken-1"
                  >pause</v-icon>
                </v-btn>
              </span>
            </span>
          </td>
          <td class="px-0">
            <span class="action-btns">
              <v-btn
                icon
                class="mx-0"
                title="Редактирование расписание опроса прибора учета"
                @click="editCounterTask(props.item)"
              >
                <v-icon color="grey darken-1">edit</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                title="Удаление расписания опроса прибора учета"
                @click="deleteCounterTask(props.item)"
              >
                <v-icon color="grey darken-1">delete</v-icon>
              </v-btn>
              <v-btn
                icon
                class="mx-0"
                title="Лог опроса прибора учета"
                @click="viewCounterTaskLog(props.item)"
              >
                <v-icon color="grey darken-1">fas fa-file-alt</v-icon>
              </v-btn>
            </span>
          </td>
        </tr>
      </v-data-table>
    </v-card>

    <v-bottom-sheet v-model="showLog">
      <task-logs :task="selectedTask" />
    </v-bottom-sheet>
  </span>
</template>

<script>
import PointToolbar from '../points/PointToolbar'
import TaskLogs from '../../shared-components/TaskLogs'
import axios from 'axios'

export default {
  name: 'PointsScheduler',
  components: {
    PointToolbar,
    TaskLogs
  },
  data () {
    return {
      inputRules: [
        v => !!v || 'Заполните это поле!'
      ],
      showLog: false,
      tmpParameters: [],
      counterTasksHeaders: [
        { text: 'Номер счётчика', sortable: false, value: 'counter_num' },
        { text: 'Выполняется', sortable: false, value: 'enabled' },
        { text: 'Действия', sortable: false, value: 'actions' }
      ],
      editedTask: false,
      editedTaskItem: { counter_id: '', parameters: [], data_collecting_server_id: '', value: '', point_id: '' },
      editedCounterTaskIndex: -1,
      taskOnceDateValue: false,
      startTaskDate: false,
      taskDialog: false,
      tasksLoading: true,
      counterTasks: [],
      pointId: this.$route.params['id'],
      editing: false,
      point: {},
      counterParameters: [],
      dataCollectingServers: [],
      sheet: false,
      sendUpdate: false,
      cronVal: '',
      addTask: false,
      selectedTask: {},
      taskGroups: [],
      tmpTaskGroups: [],
      intervalSelect: '*/30 * * * *',
      intervals: [
        { text: 'Каждые 30 минут', value: '*/30 * * * *' },
        { text: 'Каждый час', value: '0 * * * *' },
        { text: 'Раз в сутки в 00:00', value: '0 0 * * *' }
      ]
    }
  },
  computed: {
    taskDialogTitle () {
      return this.editing ? 'Редактирование задания' : 'Новое задание'
    }
  },
  watch: {
    dialog (val) {
      val || this.close()
    },
    'editedTaskItem.counter_parameters': function () {
      if (this.sendUpdate) {
        return
      }
      this.tmpParameters = []
      this.counterParameters.forEach((element) => {
        if (this.editedTaskItem.counter_parameters.includes(element.model_parameter_id)) {
          this.tmpParameters.push(element)
        }
      })
      setTimeout(() => {
        this.paramsLoading = false
      }, 1000)
    },
    tmpTaskGroups () {
      this.tmpParameters = []
      for (var idx in this.tmpTaskGroups) {
        for (var paramIdx in this.counterParameters) {
          if (this.counterParameters[paramIdx].parameter__task_group === this.tmpTaskGroups[idx].group_id) {
            this.tmpParameters.push(this.counterParameters[paramIdx])
          }
        }
      }
    }
  },
  mounted () {
    this.getTasksApi()
    this.getPointApi()
    this.getCounterAvailableParameters()
    this.getCounterAvailableServers()
  },
  methods: {
    getPointApi () {
      var self = this
      axios.get(`/api/points/${this.pointId}/`)
        .then((response) => {
          self.point = response.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getCounterAvailableParameters () {
      var self = this
      return new Promise(function (resolve, reject) {
        self.counterParameters = []
        self.taskGroups = []
        var tmpGroup = {}
        axios.get(`/api/counters_data/available_params/?point_id=${self.pointId}`)
          .then((response) => {
            self.counterParameters = self.counterParameters.concat(response.data)
            self.counterParameters.forEach(function (element) {
              if (element.parameter__task_group !== null) {
                tmpGroup[element.parameter__task_group] = element.parameter__task_group_name
              }
            })
            for (var key in tmpGroup) {
              self.taskGroups.push({ 'name': tmpGroup[key], 'group_id': key })
            }
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    getCounterAvailableServers () {
      this.dataCollectingServers = []
      var self = this
      axios.get(`/api/collecting_servers/`)
        .then((response) => {
          self.dataCollectingServers = response.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getTasksApi () {
      this.tasksLoading = true
      var self = this
      axios.get(`/api/counters_tasks/?point_id=${this.pointId}`)
        .then((response) => {
          self.counterTasks = response.data.results
          self.tasksLoading = false
        })
        .catch((err) => {
          this.tasksLoading = false
          console.log(err)
        })
    },
    closeTasks () {
      this.taskDialog = false
    },
    addTaskApi () {
      this.tasksLoading = true
      var self = this
      this.editedTaskItem.counter_parameters = []
      this.tmpParameters.forEach(function (element) {
        self.editedTaskItem.counter_parameters.push(element.model_parameter_id)
      })
      this.editedTaskItem.value = this.cronVal
      this.editedTaskItem.counter_id = this.point.counter_id
      this.editedTaskItem.point_id = this.pointId
      var taskGroup = []
      this.tmpTaskGroups.forEach(function (element) {
        taskGroup.push(element.group_id)
      })
      this.editedTaskItem.task_group = taskGroup.join(',')
      axios.post(`/api/counters_tasks/`, this.editedTaskItem)
        .then((response) => {
          this.tasksLoading = false
          this.counterTasks.push(response.data)
          this.closeTasksDialog()
        })
        .catch((err) => {
          this.tasksLoading = false
          console.log(err)
        })
    },
    updateTaskApi () {
      this.sendUpdate = true
      this.editedTaskItem.counter_parameters = []
      this.tmpParameters.forEach((element) => {
        this.editedTaskItem.counter_parameters.push(element.model_parameter_id)
      })
      const id = this.editedTaskItem.counter_task_id
      var taskGroup = []
      this.tmpTaskGroups.forEach(function (element) {
        taskGroup.push(element.group_id)
      })
      this.editedTaskItem.task_group = taskGroup.join(',')

      this.editedTaskItem.value = this.cronVal
      this.tasksLoading = true
      axios.put(`/api/counters_tasks/${id}/`, this.editedTaskItem)
        .then((response) => {
          this.sendUpdate = false
          this.tasksLoading = false
          Object.assign(this.counterTasks[this.editedCounterTaskIndex], response.data)
          this.closeTasksDialog()
        })
        .catch((err) => {
          this.sendUpdate = false
          this.tasksLoading = false
          console.log(err)
        })
    },
    deleteCounterTask (item) {
      const id = item.counter_task_id
      this.tasksLoading = true
      axios.delete(`/api/counters_tasks/${id}/`)
        .then((response) => {
          this.tasksLoading = false
          const index = this.counterTasks.indexOf(item)
          this.counterTasks.splice(index, 1)
        })
        .catch((err) => {
          this.tasksLoading = false
          console.log(err)
        })
    },
    startCounterTaskApi (item) {
      const id = item.counter_task_id
      axios.post(`/api/counters_tasks/${id}/start_scheduler/`)
        .then((response) => {
          const index = this.counterTasks.indexOf(item)
          Object.assign(this.counterTasks[index], response.data)
          this.editedTaskItem = Object.assign({}, response.data)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    stopCounterTaskApi (item) {
      const id = item.counter_task_id
      axios.post(`/api/counters_tasks/${id}/stop_scheduler/`)
        .then((response) => {
          const index = this.counterTasks.indexOf(item)
          Object.assign(this.counterTasks[index], response.data)
          this.editedTaskItem = Object.assign({}, response.data)
        })
        .catch((err) => {
          console.log(err)
        })
    },
    editCounterTask (item) {
      this.sendUpdate = false
      this.editedCounterTaskIndex = this.counterTasks.indexOf(item)
      this.editedTaskItem = Object.assign({}, item)
      this.cronVal = this.editedTaskItem.value
      if (this.cronVal.includes('30')) {
        // solution for old values
        this.cronVal = '*/30 * * * *'
      }
      this.editing = true
      this.addTask = true
      this.tmpTaskGroups = []
      if (this.editedTaskItem.task_group != null) {
        var taskGroups = this.editedTaskItem.task_group.split(',')
        this.taskGroups.forEach((element) => {
          if (taskGroups.includes(element.group_id)) {
            this.tmpTaskGroups.push(element)
          }
        })
      }
    },
    addCounterTask () {
      this.editing = false
      this.taskDialog = true
      this.addTask = true
    },
    saveCounterTask () {
      if (this.validate()) {
        if (this.editing === true) {
          this.updateTaskApi()
        } else {
          this.addTaskApi()
        }
        this.addTask = false
      }
    },
    closeTasksDialog () {
      this.taskDialog = false
      this.editing = false
      this.addTask = false
    },
    stopTasks (item) {
      this.stopCounterTaskApi(item)
    },
    startTasks (item) {
      this.startCounterTaskApi(item)
    },
    viewCounterTaskLog (item) {
      this.selectedTask = item
      this.showLog = true
      this.editedCounterTaskIndex = this.counterTasks.indexOf(item)
    },
    validate () {
      if (this.$refs.scheduleForm.validate()) {
        return true
      }
    }
  }
}
</script>

<style lang="scss">
  .is_invisible {
    display: none;
  }
  .right_pos {
    float: right;
  }
  .log_card {
    position: absolute;
    bottom: 0px;
    right: 0;
    z-index: 3;
    box-shadow: 0 0 10px rgba(0,0,0,0.5);
    height: 300px;
  }
  .v-btn.add-scheduler-button {
    position: absolute;
    right: 15px;
    z-index: 3;
  }
  .v-card.point-sheduler-card {
    position: unset;
    .v-data-table {
      position: absolute;
      height: calc(100% - 64px);
      right: 0;
      left: 0;
    }
    .v-data-table__wrapper {
      max-height: 100%;
    }
  }
  .action-btns {
    white-space: nowrap;
  }
</style>



// WEBPACK FOOTER //
// src/spa/points/PointScheduler.vue